// extracted by mini-css-extract-plugin
export default {"mainBox":"ComposeMail_mainBox__A0Moc","home":"ComposeMail_home__svQVZ","formContainer":"ComposeMail_formContainer__-I12-"};